import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SewMarkdown } from '@sew/ui-components-angular/standalone';
import { CustomBreakpoint } from '../../../../helpers/breakpoint.helper';
import { Content } from '../../../../models/blog-posts.model';
import { ReplaceLinebreakPipe } from '../../../../pipes/replace-linebreak/replace-linebreak.pipe';
import { PictureComponent } from '../picture/picture.component';

@Component({
    selector: 'blog-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss'],
    imports: [CommonModule, PictureComponent, ReplaceLinebreakPipe, SewMarkdown],
})
export class TextComponent implements OnInit {
    @Input() public content?: Content;
    @Input() public breakpoint?: CustomBreakpoint;

    public text = '';

    public ngOnInit(): void {
        if (this.content?.text) {
            this.text = this.content.text;
        }
    }
}
